document.addEventListener('DOMContentLoaded', function () {
  // Remember which contact form was submitted (click)
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('button[type="submit"],input[type="submit"]');
    if (!btn) return;
    const form = btn.closest('form');
    if (form && form.action && form.action.indexOf('/contact') !== -1) {
      sessionStorage.setItem('submittedContactFormId', form.id || '');
    }
  }, true);

  // Also remember on Enter-key submit
  document.querySelectorAll('form[action^="/contact"]').forEach(f => {
    f.addEventListener('submit', () => {
      sessionStorage.setItem('submittedContactFormId', f.id || '');
    });
  });

  // After redirect, reveal messages only for that form
  if (/[?&](contact_posted=true|form_type=contact)/.test(location.search)) {
    const id = sessionStorage.getItem('submittedContactFormId');
    if (id) {
      const targetForm = document.getElementById(id);
      if (targetForm) {
        targetForm.querySelectorAll('[data-contact-success],[data-contact-errors]')
          .forEach(el => el.removeAttribute('hidden'));
      }
    }
    // Do NOT clear the key here if it's the leasing form; drawer.js will use it.
    if (id !== 'leasing_contact_form') {
      sessionStorage.removeItem('submittedContactFormId');
    }
  }
});
